//
//
//
//

export default {
  props: {
    num: {
      type: Number, default: 0
    },
    type: {
      type: Number, default: 0
    },
    barData: {
      type: Array, default: () => []
    }
  },
  data () {
    return {
      newBarData: [],
      xData: [],
      lateralBarCharts: null
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.lateralBarCharts?.resize()
    },
    barData: {
      handler (newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  beforeDestroy () {
    this.lateralBarCharts?.clear() // 清空当前实例
    this.lateralBarCharts?.dispose() // 销毁图表
    this.lateralBarCharts = null
  },
  methods: {
    getData () {
      this.newBarData = []
      this.xData = []
      this.barData?.forEach((item, index) => {
        if (this.num == 0) {
          this.xData.push(index)
          this.newBarData.push({
            name: item.Low + ':00' + '-' + item.High + ':00',
            value: item.Num
          })
        } else {
          this.xData.push(item.Low)
          this.newBarData.push({
            name: item.Low + '-' + item.High,
            value: item.Num
          })
        }
      })
      this.getBarCharts()
    },
    getBarCharts () {
      if (!this.lateralBarCharts) this.lateralBarCharts = this.$echarts.init(document.getElementsByClassName('lateral-bar-charts')[this.type ? 0 : this.num])
      const option = {
        tooltip: {
          confine: true,
          backgroundColor: 'rgba(0,0,0,.7)',
          formatter: (params) => {
            return `<div class="tooltip-box">
            <div class="item"><span>${this.num == 1 ? this.$t('TYY_000462') : this.$t('TYY_000305')}: </span>${params.name}</div>
            <div class="item"><span>${this.$t('TYY_000123')}: </span>${params.value}</div>
            </div>`
          }
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#A3A3A3',
              // rotate: 40
              margin: 30
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: ['rgba(0, 0, 0, 0.05)']
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'category',
            axisLabel: {
              color: '#A3A3A3'
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            data: this.xData
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            // barWidth: 16,
            barMaxWidth: 16,
            itemStyle: {
              normal: {
                color: '#5C8AE5',
                borderRadius: [0, 10, 10, 0]
              },
              emphasis: {
                color: '#96B9FF'
              }
            },
            data: this.newBarData
          }
        ]
      }
      this.lateralBarCharts?.clear()
      this.lateralBarCharts?.setOption(option, true)
    }
  }
}
